// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__DVIOl","bottom":"Card_bottom__PF1YZ"};